import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { showToast } from "@/modules/common/utils";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { queryClient } from "@/queryClient";
import { useContext, useMemo } from "react";
import { useMutation } from '@tanstack/react-query';
import { LeadTag } from "@/modules/lead-tags/dtos";
import useGetLeadTags from "@/modules/lead-tags/hooks/get-lead-tags.hook";
import { addLeadTag } from "@/modules/lead-page/api/lead-page.v2.api";
const useAddLeadTag = (setOpen: (open: boolean) => void) => {
  const { lead } = useContext(LeadPageContext);
  const { tags } = useGetLeadTags();

  const {
    mutate: addLeadTagMutation,
    isLoading,
    isSuccess,
  } = useMutation(
    (params: { leadUId: string; tagUIds: string[] }) =>
      addLeadTag(params.leadUId, params.tagUIds),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["getLead"] });
        queryClient.invalidateQueries({ queryKey: ["lead-activity"] });
        showToast({
          type: ToastType.SUCCESS,
          toastId: TOAST_IDS.CREATE_LEAD_TAG_SUCCESS,
          message: "Lead tag added successfully",
          options: {
            position: "bottom-left",
            autoClose: 3000,
          },
        });
        setOpen(false);
      },
      onError: () => {
        showToast({
          type: ToastType.ERROR,
          toastId: TOAST_IDS.CREATE_LEAD_TAG_ERROR,
          message: "Failed to add lead tag",
          options: {
            position: "bottom-left",
            autoClose: 3000,
          },
        });
      },
    }
  );

  const filteredTags = useMemo(() => {
    return (
      tags.filter(
        (tag: LeadTag) =>
          !lead?.data?.lead?.leadTags?.some((t) => t.uid === tag.uid)
      ) || []
    );
  }, [tags, lead?.data?.lead?.leadTags]);

  return {
    filteredTags,
    addLeadTagMutation,
    isLoading,
    lead,
    isSuccess,
  };
};

export default useAddLeadTag;
